import moment from 'moment';

const formatRelativeTimeAgo = (value) => {
  if (!value) {
    return null;
  }
  const date = moment(value);
  if (!date.isValid()) {
    return null;
  }
  const seconds = moment().diff(date, 'seconds');
  if (seconds < 60) {
    return 'just now';
  }
  const minutes = moment().diff(date, 'minutes');
  if (minutes < 60) {
    return `${minutes}m ago`;
  }
  const hours = moment().diff(date, 'hours');
  if (hours < 24) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  }
  const days = moment().diff(date, 'days');
  if (days < 7) {
    return days === 1 ? '1 day ago' : `${days} days ago`;
  }
  return date.fromNow();
};

export default formatRelativeTimeAgo;
